import React, {useContext} from "react";

// context and providers
import {CatalogueContext} from "../../../../context";

// config
import config from "../../../../config";

// components
import {Block, HtmlHeader, Sidebar, SidebarItem, Scaffolding, Testimonials} from "../../../shared"
import ShoppingList from "../ShoppingList"
import Filter from "./Filter"
import List from "./List"
//import ListHomedelivery from "./ListHomedelivery"
import Hero from "./Hero"
import Heading from "./Heading"

// sidebar component
function SearchSidebar() {
  return (
    <Sidebar className="search">
      <SidebarItem title="Erlebnis-Filter">
        <Filter position="sidebar" />
      </SidebarItem>
      <SidebarItem title="Dein Warenkorb">
        <ShoppingList />
      </SidebarItem>
      {/*}
      <SidebarItem title="Kundenmeinungen">
        <Testimonials mode="desktop" />
      </SidebarItem>
      */}
    </Sidebar>
  )
}


// the component
const Search = () => {
  // contexts
  let catalogue = useContext(CatalogueContext)

  // some content is only displayed if catalogue is ready
  let content = null

  // TODO this is only used while developing the shop
  let sidebarPosition = (config.layout.sidebarPosition === "left" || config.layout.sidebarPosition === "mixed") ? "left" : "right"

  
  if(catalogue.isReady) {
    content = (
      <Block 
        sidebar={<SearchSidebar />} 
        sidebarPosition={sidebarPosition}
        console={<Filter />}
        heading={<Heading />}
        renderAfter={(mode) => mode === "mobile" ? <Testimonials mode="mobile" /> : null }
      >
        <HtmlHeader title="Appentura - kreiere ein unvergessliches Erlebnis" />
          {/* <ListHomedelivery /> */}
          <List />
      </Block>
    )
  }

  // render
  return(
    <Scaffolding>
      <Hero />
      {content}
    </Scaffolding>
  )
}

export default Search